import React, { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import CommonCard from '../global/card';
import CommonForm from '../global/form';
import CommonDatePicker from '../global/datePicker';
import SOURCES from '../../utils/constants';
import { useKey } from '../../services/useKey';
import dayjs from 'dayjs';

const EnhancedAdvanceSearchAffiliates = ({
    setShowAdvanceSearch,
    setAdvanceSearch,
    advanceSearch,
}) => {
    const [searched, setSearched] = useState(false);
    const [form] = Form.useForm();

    useKey(() => setSearched(true), "Enter");
    useKey(() => {
        setShowAdvanceSearch(false);
        setAdvanceSearch({
            ...advanceSearch,
            advance_search_enabled: searched
                ? SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_CLOSED_SEARCH_FORM
                : SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
        });
    }, "Escape");

    const onSearch = () => {
        form
            .validateFields()
            .then(async (values) => {
                const hasValues =
                    values.startDate ||
                    values.endDate ||
                    values.searchTerm;

                if (!hasValues) {
                    setAdvanceSearch({
                        ...advanceSearch,
                        advance_search_enabled:
                            SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
                    });
                    message.error("Please fill at least one field.");
                    return;
                }

                const userTZ = dayjs.tz.guess();

                setAdvanceSearch({
                    ...advanceSearch,

                    startDate: values.startDate
                        ? new Date(values.startDate.format('YYYY-MM-DD'))
                        : advanceSearch.startDate,

                    endDate: values.endDate
                        ? new Date(values.endDate.format('YYYY-MM-DD'))
                        : advanceSearch.endDate,

                    searchTerm: values.searchTerm || "",

                    advance_search_enabled:
                        SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_FILTER,
                });
            })
            .catch((err) => {
                console.log("Validation failed", err);
            });
    };

    const formData = [
        {
            label: "Start Date",
            name: "startDate",
            inputType: SOURCES.FORMINPUTTYPES.DATE,
            type: "date",
            placeholder: "Start Date",
            required: false,
            span: 12,
        },
        {
            label: "End Date",
            name: "endDate",
            inputType: SOURCES.FORMINPUTTYPES.DATE,
            type: "date",
            placeholder: "End Date",
            required: false,
            span: 12,
        },
        {
            label: "Search",
            name: "searchTerm",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            type: "text",
            placeholder: "Search",
            required: false,
            span: 24,
        }
    ];

    return (
        <CommonCard
            title="Advance Search"
            isExtraButton={{
                show: [
                    "startDate",
                    "endDate",
                    "searchTerm",
                ].some((key) => advanceSearch[key] && advanceSearch[key] !== "" && !(advanceSearch[key] instanceof Date && advanceSearch[key].toString() === "Invalid Date")),
                data: [
                    {
                        title: "Clear",
                        onClick: () => {
                            setAdvanceSearch({
                                ...advanceSearch,
                                startDate: "",
                                endDate: "",
                                searchTerm: "",
                                advance_search_enabled:
                                    SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
                            });
                            form.resetFields();
                        },
                    }
                ]
            }}
            className={"max-w-[650px] w-full shadow-2xl"}
        >
            <CommonForm
                data={formData}
                className="mt-4"
                layoutType="vertical"
                form={form}
            />
            <div className="flex justify-end">
                <Button
                    key="confirm"
                    type="primary"
                    className="!bg-primary text-white h-10 min-w-[130px]"
                    onClick={onSearch}
                >
                    Search
                </Button>
            </div>
        </CommonCard>
    );
};

export default EnhancedAdvanceSearchAffiliates;
